export default "__VITE_ASSET__5lk3ufl5__"